let elementAnimationObject=()=>[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:'initial'}];export default{"initial.extension.annotation":()=>({"polypath.appearing":elementAnimationObject,"text.appearing":elementAnimationObject,"image.appearing":elementAnimationObject,"ellipse.appearing":elementAnimationObject,"ringpath.appearing":elementAnimationObject,"path.appearing":elementAnimationObject,"rect.appearing":elementAnimationObject,"*":null})};


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-features/src/annotation/annotation-animation.js
// module id = null
// module chunks = 